<template>
  <div class="main-content" align="center">
    <img src="./images/10.png" v-if="newCoupon === 0" class="img-1" />
    <p class="label-1" v-if="newCoupon === 0">领取成功</p>
    <p class="label-2" v-if="newCoupon === 0">微信搜索“GoFun车主服务”小程序</p>
    <p class="label-2" v-if="newCoupon === 0">在“我的”-“我的券包”查看</p>
    <p class="label-3" v-if="newCoupon === 1">抱歉，您已领取过首单优惠～</p>
    <p class="label-2" v-if="newCoupon === 1">前往“GoFun车主服务”小程序</p>
    <p class="label-2" v-if="newCoupon === 1">尊享专业车主服务</p>
    <div class="code-main">
      <img src="./images/11.png" />
      <p v-if="isInWeChat">长按扫码前往“GoFun车主服务”</p>
      <p v-if="!isInWeChat">截屏，并使用微信“扫一扫”功能扫描图片</p>
      <p v-if="!isInWeChat">前往“GoFun车主服务”</p>
    </div>
  </div>
</template>

<script>
import { checkIsWeixin } from "@/libs/utils";
export default {
  name: "receiveSuccess",
  data() {
    return {
      isInWeChat: false, // 是否在微信客户端里
      newCoupon: 0 //是否领取优惠券，0未领取，1代表已领取
    };
  },
  mounted() {
    this.newCoupon = parseInt(this.$route.query.newCoupon);
    this.isInWeChat = checkIsWeixin();
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
  height: 100vh;
  background: rgb(250, 249, 248);
  padding-top: 70px;
  .img-1 {
    width: 92px;
    margin-bottom: 24px;
  }
  .label-1 {
    font-family: FZLTCHJW--GB1-0;
    font-size: 48px;
    color: #141e25;
    letter-spacing: 0;
    text-align: center;
    margin: 0;
    font-weight: bold;
    padding-bottom: 9px;
  }
  .label-2 {
    font-family: FZLTHJW--GB1-0;
    font-size: 26px;
    color: #778690;
    letter-spacing: 0;
    text-align: center;
    line-height: 38px;
    margin: 0;
    padding-top: 4px;
  }
  .label-3 {
    font-family: FZLTCHJW--GB1-0;
    font-size: 38px;
    color: #141e25;
    letter-spacing: 0;
    text-align: center;
    margin: 0;
    padding-bottom: 11px;
    font-weight: bold;
  }
  .code-main {
    width: 662px;
    height: 676px;
    margin-top: 54px;
    background: #ffffff;
    border: 2px solid #e4ecf2;
    border-radius: 18px;
    img {
      width: 370px;
      margin-top: 104px;
      margin-bottom: 24px;
    }
    p {
      font-family: FZLTHJW--GB1-0;
      font-size: 26px;
      color: #778690;
      letter-spacing: 0;
      text-align: center;
      line-height: 38px;
    }
  }
}
</style>
